export default function calculateImageTopPosition(galleryHeight, imageHeight) {
    if (imageHeight < galleryHeight) {
        return (galleryHeight - imageHeight) / 2;
    }

    return 0;
}
